<div class="predefined-container" fxLayout="column" fxLayoutAlign="center stretch">
    <div>
        <mat-card-title>{{'predefinedMessage' | translate}}</mat-card-title>
        <mat-icon fxFlex="nogrow" class="mr-0 ml-auto" [mat-dialog-close]="false" svgIcon="close"></mat-icon>
    </div>
    <mat-dialog-content fxFlex="auto" class="pt-3" fxLayout="column">
        <form *ngIf="form" [formGroup]="form" fxLayout="column">
            <input type="hidden" formControlName="id">
            <mat-form-field>
                <mat-label>{{'messageType' | translate}}</mat-label>
                <mat-select formControlName="icon">
                        <mat-option *ngFor="let icon of ICONS" [value]="icon.icon">
                            <mat-icon [svgIcon]="icon.icon" class="{{icon.name}}"></mat-icon>
                            {{icon.name | translate}}
                        </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'message' | translate}}</mat-label>
                <textarea class="text-area" matInput formControlName="message">{{data.message}}</textarea>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions fxFlex="nogrow">
        <button class="mr-0 ml-auto" mat-raised-button color="sims" (click)="save()" [disabled]="!form.valid">{{'save' | translate}}</button>
    </mat-dialog-actions>
</div>